exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager #delete-modal p{font-size:14px;color:#5b6981}", ""]);

// exports
